import axios from "axios";
import { toast } from "react-toastify";
import { friendlyError } from "../../common/apiError";
import { logout } from "./userActions";
import { ToastObjects } from "./toastObject";
import {
    APP_WEBHOOK_GET_REQUEST,
    APP_WEBHOOK_GET_SUCCESS,
    APP_WEBHOOK_GET_FAIL,
    APP_WEBHOOK_UPDATE_REQUEST,
    APP_WEBHOOK_UPDATE_SUCCESS,
    APP_WEBHOOK_UPDATE_FAIL,
    APP_WEBHOOK_ROTATE_REQUEST,
    APP_WEBHOOK_ROTATE_SUCCESS,
    APP_WEBHOOK_ROTATE_FAIL,
    APP_WEBHOOK_DELIVERIES_REQUEST,
    APP_WEBHOOK_DELIVERIES_SUCCESS,
    APP_WEBHOOK_DELIVERIES_FAIL,
} from "../constants/AppWebhookConstants";

export const getAppWebhook = (appId) => async (dispatch) => {
    try {
        dispatch({ type: APP_WEBHOOK_GET_REQUEST });
        const response = await axios.get(`users/app/${appId}/webhook`);
        dispatch({ type: APP_WEBHOOK_GET_SUCCESS, payload: response.data.data || {} });
    } catch (error) {
        const status = error?.response?.status;
        if (status === 401) {
            dispatch(logout());
        } else {
            toast.error(friendlyError(error));
        }
        dispatch({ type: APP_WEBHOOK_GET_FAIL, payload: error?.message });
    }
};

export const updateAppWebhook = (appId, patch) => async (dispatch) => {
    try {
        dispatch({ type: APP_WEBHOOK_UPDATE_REQUEST });
        const response = await axios.patch(`users/app/${appId}/webhook`, patch);
        dispatch({ type: APP_WEBHOOK_UPDATE_SUCCESS, payload: response.data.data });
        toast.success(response.data.message || "Webhook updated.", ToastObjects);
        dispatch(getAppWebhook(appId));
    } catch (error) {
        const status = error?.response?.status;
        if (status === 401) {
            dispatch(logout());
        } else {
            toast.error(friendlyError(error));
        }
        dispatch({ type: APP_WEBHOOK_UPDATE_FAIL, payload: error?.message });
    }
};

export const rotateAppWebhookSecret = (appId) => async (dispatch) => {
    try {
        dispatch({ type: APP_WEBHOOK_ROTATE_REQUEST });
        const response = await axios.post(`users/app/${appId}/webhook/rotate`);
        dispatch({ type: APP_WEBHOOK_ROTATE_SUCCESS, payload: response.data.data });
        toast.success(response.data.message || "Secret rotated.", ToastObjects);
        dispatch(getAppWebhook(appId));
    } catch (error) {
        const status = error?.response?.status;
        if (status === 401) {
            dispatch(logout());
        } else {
            toast.error(friendlyError(error));
        }
        dispatch({ type: APP_WEBHOOK_ROTATE_FAIL, payload: error?.message });
    }
};

export const getAppWebhookDeliveries = (appId) => async (dispatch) => {
    try {
        dispatch({ type: APP_WEBHOOK_DELIVERIES_REQUEST });
        const response = await axios.get(`users/app/${appId}/webhook/deliveries`);
        dispatch({ type: APP_WEBHOOK_DELIVERIES_SUCCESS, payload: response.data.data || [] });
    } catch (error) {
        const status = error?.response?.status;
        if (status === 401) {
            dispatch(logout());
        } else {
            toast.error(friendlyError(error));
        }
        dispatch({ type: APP_WEBHOOK_DELIVERIES_FAIL, payload: error?.message });
    }
};
